import InfoTileContainer from '../Info-Tile/InfoTileContainer';
import NotificationBannerContainer from '../Notification-Banner/NotificationBannerContainer';
import BannerContainer from '../Troubleshooting-Banner/BannerContainer';
import UtteranceTilesContainer from '../Utterance-Tiles/UtteranceTilesContainer';

/**
 * @name TroubleshootingTool
 * @param {object} props - Strapi and url query params data
 * @returns {JSX.Element} - Renders Troubleshooting tool
 */
const TroubleshootingTool = props => (
  <>
    {props.hasNotification && (
      <NotificationBannerContainer
        cmsData={props?.cmsData?.data?.attributes?.Notification_Banner}
      />
    )}
    <BannerContainer
      cmsData={props?.cmsData?.data?.attributes?.Troubleshooting_Banner_1}
      handleAction={props.handleAction}
    />
    <UtteranceTilesContainer
      cmsData={props?.cmsData?.data?.attributes?.Utterance_Tiles}
      sweeprParams={props?.sweeprParams}
      setSweeprParams={props?.setSweeprParams}
      showLoginVerificationModal={props?.showLoginVerificationModal}
      handleAction={props.handleAction}
    />
    <InfoTileContainer
      cmsData={props?.cmsData?.data?.attributes?.Info_Tile}
      handleAction={props.handleAction}
    />
    <BannerContainer
      cmsData={props?.cmsData?.data?.attributes?.Troubleshooting_Banner_2}
      isSecondBanner
      handleAction={props.handleAction}
    />
  </>
);

TroubleshootingTool.displayName = 'TroubleshootingTool';
export default TroubleshootingTool;
